import React from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Routes from './routes';

import IntroductionScreen from '../screens/IntroductionScreen/IntroductionScreen';
import HomeScreen from '../screens/Home';
import QualificationScreen from '../screens/QualificationScreen';
import CategoriesScreen from '../screens/CategoriesScreen';
import AddressScreen from '../screens/AddressScreen';
import DeclarationScreen from '../screens/DeclarationScreen';
import SuccessScreen from '../screens/SuccessScreen';
import FileUploadScreen from '../screens/FileUploadScreen';
import SummaryScreen from '../screens/SummaryScreen';

const {
  addressScreen,
  categoriesScreen,
  declarationScreen,
  qualificationScreen,
  home,
  fileUploadScreen,
  successScreen,
  introduction,
  summaryScreen,
} = Routes;

const Navigation = () => (
  <Router basename={process.env.REACT_APP_SUBFOLDER}>
    <Switch>
      <Route
        path={successScreen.path}
        component={SuccessScreen}
        {...successScreen.props}
      />
      <Route
        path={fileUploadScreen.path}
        component={FileUploadScreen}
        {...fileUploadScreen.props}
      />
      <Route path={summaryScreen.path} component={SummaryScreen} />
      <Route
        path={declarationScreen.path}
        component={DeclarationScreen}
        {...declarationScreen.props}
      />
      <Route
        path={addressScreen.path}
        component={AddressScreen}
        {...addressScreen.props}
      />
      <Route
        path={categoriesScreen.path}
        component={CategoriesScreen}
        {...categoriesScreen.props}
      />
      <Route
        path={qualificationScreen.path}
        component={QualificationScreen}
        {...qualificationScreen.props}
      />
      <Route path={home.path} component={HomeScreen} {...home.props} />
      <Route path={introduction.path} component={IntroductionScreen} />
    </Switch>
  </Router>
);

export default Navigation;
